<pin-dialog>
  <pin-dialog-title>Your session is about to end due to inactivity.</pin-dialog-title>

  <pin-dialog-content>
    <p class="dcp-body">Click Continue to keep working.</p>
  </pin-dialog-content>

  <pin-dialog-actions align="end">
    <pin-button buttonStyle="filled" (buttonClick)="continue()">CONTINUE</pin-button>
  </pin-dialog-actions>
</pin-dialog>
